import mixins from 'vue-typed-mixins';

import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';

import AbstractデータService from '@/classes/service/AbstractデータService';

export default mixins(計画書Mixin).extend({
  name: 'MoneyUnitLabelMixin',

  data(): {
    moneyUnitLabel: string;
  } {
    return {
      moneyUnitLabel: '',
    };
  },

  watch: {
    '計画書.c千円表示フラグ': {
      handler(): void {
        this.setMoneyUnitLabel();
      },
    },
  },

  created(): void {
    this.setMoneyUnitLabel();
  },

  methods: {
    setMoneyUnitLabel(): void {
      this.moneyUnitLabel = AbstractデータService.getMoneyUnitLabel();
    },
  },
});
